// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlayCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PlayCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PlayCircleOutlined = function PlayCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleOutlinedSvg
  }));
};

PlayCircleOutlined.displayName = 'PlayCircleOutlined';
export default React.forwardRef(PlayCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlayCircleOutlined.js
// module id = 3806
// module chunks = 0